import { NgModule } from "@angular/core";
import { CertificateCrudModule } from "../key/certificate";
import { PrivateKeyCrudModule } from "../key/private-key";
import { SharedModule } from "../shared";
import { ClientFormComponent } from "./client-form.component";
import { ClientListComponent } from "./client-list.component";
import { ClientRoutingModule } from "./client-routing.module";
import { ClientService } from "./crud.service";

const DIRECTIVES = [ClientFormComponent, ClientListComponent];

@NgModule({
	imports: [
		SharedModule,
		ClientRoutingModule,
		PrivateKeyCrudModule,
		CertificateCrudModule,
	],
	providers: [ClientService],
	declarations: [...DIRECTIVES],
	exports: [...DIRECTIVES],
})
export class ClientCrudModule {}
